const r = {
  transition: "transitionend",
  WebkitTransition: "webkitTransitionEnd",
  MozTransition: "transitionend",
  OTransition: "oTransitionEnd otransitionend"
};
let o;
if (typeof document < "u") {
  const {
    style: i
  } = document.createElement("div"), n = Object.keys(r);
  for (let t = 0, e = n[t]; t < n.length; t += 1, e = n[t])
    if (e in i) {
      o = r[e];
      break;
    }
}
const s = (i, n, t) => {
  if (!i) return;
  i.addEventListener(o, n);
  let e;
  return t && (e = setTimeout(() => {
    i.removeEventListener(o, n), n();
  }, t)), () => {
    clearTimeout(e), i.removeEventListener(o, n);
  };
};
export {
  s as default
};
